import { company } from '../data/company';
import { coreValues } from '../data/values';
import SectionHeading from '../components/ui/SectionHeading';
import AnimatedSection from '../components/ui/AnimatedSection';
import ValueCard from '../components/ui/ValueCard';
import CountUp from '../components/ui/CountUp';
import CTABanner from '../components/sections/CTABanner';
import { Target, Eye, User } from 'lucide-react';

export default function About() {
  return (
    <>
      <section className="pt-32 pb-16 bg-gradient-to-b from-charcoal-900 to-charcoal-800">
        <div className="container-custom">
          <AnimatedSection>
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="heading-1 text-white mb-6">
                About Us
              </h1>
              <p className="text-xl md:text-2xl font-semibold text-charcoal-200 mb-4">
                Building Jamaica's Future Since {company.foundedYear}
              </p>
              
            </div>
          </AnimatedSection>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <AnimatedSection>
              <div>
                <span className="text-sm font-semibold text-primary-600 uppercase tracking-wider mb-3 block">
                  Our Story
                </span>
                <h2 className="heading-2 text-charcoal-900 mb-6">
                  A Legacy of Quality Construction
                </h2>
                <div className="space-y-4 text-charcoal-600 leading-relaxed">
                  <p>{company.description}</p>
                </div>

                <div className="mt-8 p-6 bg-charcoal-50 rounded-2xl">
                  <div className="flex items-center gap-4">
                    <div className="p-3 bg-primary-100 rounded-xl">
                      <User className="w-6 h-6 text-primary-600" />
                    </div>
                    <div>
                      <p className="font-semibold text-charcoal-900">
                        {company.founder}
                      </p>
                      <p className="text-sm text-charcoal-600">
                        Founder & Director
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </AnimatedSection>

            <AnimatedSection delay={0.2}>
              <div className="relative">
                <img
                  src="https://images.pexels.com/photos/585419/pexels-photo-585419.jpeg?auto=compress&cs=tinysrgb&w=800"
                  alt="Construction site"
                  className="rounded-2xl shadow-xl"
                />
                <div className="absolute -bottom-6 -left-6 bg-primary-600 text-white p-6 rounded-2xl shadow-lg">
                  <div className="text-4xl font-bold">
                    <CountUp end={new Date().getFullYear() - company.foundedYear} duration={2} suffix="+" />
                  </div>
                  <div className="text-sm text-primary-100">
                    Years of Excellence
                  </div>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      <section className="section-padding bg-charcoal-50">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 gap-12">
            <AnimatedSection>
              <div className="bg-white p-8 rounded-2xl border border-charcoal-100 h-full">
                <div className="p-3 bg-primary-50 rounded-xl w-fit mb-6">
                  <Target className="w-6 h-6 text-primary-600" />
                </div>
                <h3 className="text-xl font-bold text-charcoal-900 mb-4">
                  Our Mission
                </h3>
                <p className="text-charcoal-600 leading-relaxed">
                  {company.mission}
                </p>
              </div>
            </AnimatedSection>

            <AnimatedSection delay={0.1}>
              <div className="bg-white p-8 rounded-2xl border border-charcoal-100 h-full">
                <div className="p-3 bg-primary-50 rounded-xl w-fit mb-6">
                  <Eye className="w-6 h-6 text-primary-600" />
                </div>
                <h3 className="text-xl font-bold text-charcoal-900 mb-4">
                  Our Vision
                </h3>
                <p className="text-charcoal-600 leading-relaxed">
                  {company.vision}
                </p>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      <section className="section-padding bg-white">
        <div className="container-custom">
          <AnimatedSection>
            <SectionHeading
              subtitle="Our Values"
              title="The Principles That Guide Us"
              description="Our core values shape every decision and action we take, ensuring consistent quality and integrity."
            />
          </AnimatedSection>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
            {coreValues.map((value, index) => (
              <ValueCard
                key={index}
                title={value.title}
                description={value.description}
                icon={value.icon}
                index={index}
              />
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </>
  );
}
